import { ADOBE_TOPICS, COMMON_TAGGING_PROPERTIES } from 'sg-adobe-analytics';
import { publish } from '@jutro/events';
import _ from 'lodash';
import moment from 'moment';
import SgQnBLobSpecificUtil from 'sg-qnb-lob-specific-util';
import SgCepLobSpecificUtil from 'sg-cep-lob-specific-util';

const trackChat = () => {
    publish(ADOBE_TOPICS.ADOBE_EVENT, { adobeID: COMMON_TAGGING_PROPERTIES.chatOpened, value: 'yes' });
};

const openHours = (product) => {
    const Saturday = 6;
    const Sunday = 0;
    const isSunday = moment().day() === Sunday;
    const isSaturday = moment().day() === Saturday;
    let chatAvailable;
    const chatTime = product ? SgCepLobSpecificUtil.getProductSpecificWebChatOpenTime(product) : SgQnBLobSpecificUtil.getWebChatOpenTime();

    if ((!isSaturday && !isSunday) && moment().isBetween(chatTime.startTime, chatTime.endTime)) {
        chatAvailable = true;
    } else chatAvailable = !!(isSaturday && moment().isBetween(chatTime.startTime, chatTime.saturdayEndTime));
    return chatAvailable;
};

const showQuoteNumber = (model) => {
    return !_.isNil(model)
        && model.baseData.policyPeriodStatus_Ext
        && model.baseData.policyPeriodStatus_Ext === 'Quoted'
        && window.location.hash.indexOf('retrieve') === -1
        && window.location.hash.indexOf('HospitalLocator') === -1;
};

const quoteNumber = (model) => {
    let quoteId;
    if (!_.isNil(model) && model.quoteID) {
        quoteId = model.quoteID;
    }
    return quoteId;
};

export default {
    trackChat,
    openHours,
    showQuoteNumber,
    quoteNumber
};
